import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {useQuery} from "@tanstack/react-query";
import Loader from "../../../../components/template/loader.jsx";
import userService from "../../../../services/web/user-service.js";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const handleInput = useGeneralInputSpecialCase(setFilters);

    const {dispatchNature, dispatchNatureGroups} = useReportFiltersFetch({
        fetchDispatchNature: true,
        fetchDispatchNatureGroups: true
    })


    const {data: agents = [], isLoadingAgents} = useQuery({
        queryFn: userService.allowedOnlyWithId,
        queryKey: ['users']
    })
    const {data: leaders = [], isLoadingLeaders} = useQuery({
        queryFn: userService.leaderIdentification,
        queryKey: ['leaders']
    })


    return (
        <>
            {(isLoadingAgents || isLoadingLeaders) && <Loader/>}
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>
                    <div>
                        <InputDateTime
                            id="dtStart"
                            label="Data inicial *"
                            selected={filters.dtStart}
                            onChange={(date) => handleInput('dtStart', date)}
                            classNameWrapper={"w-full"}
                            dateFormat="L"
                        />
                    </div>
                    <div>
                        <InputDateTime
                            id="dtEnd"
                            label="Data final *"
                            selected={filters.dtEnd}
                            onChange={(date) => handleInput('dtEnd', date)}
                            classNameWrapper={"w-full"}
                            dateFormat="L"
                        />
                    </div>
                    <div>
                        <SelectComponent
                            instanceId="userId"
                            label="Agente *"
                            isDisabled={filters.leaderId}
                            options={agents}
                            value={agents.find(el => el.value === filters?.userId?.value) ?? null}
                            onChange={selected => handleInput('userId', selected)}
                        />
                    </div>
                    <div>
                        <SelectComponent
                          instanceId="leaderId"
                          label="Responsável *"
                          isDisabled={filters.userId}
                          options={leaders}
                          value={leaders.find(el => el.value === filters?.leaderId?.value) ?? null}
                          onChange={selected => handleInput('leaderId', selected)}
                        />
                    </div>
                    <div>
                        <SelectComponent
                          instanceId="reason"
                          label="Natureza"
                          isMulti={true}
                          options={dispatchNature}
                          value={dispatchNature.filter(el => filters.nature.includes(el))}
                          onChange={selected => handleInput('nature', selected)}
                        />
                    </div>
                    <div>
                        <SelectComponent
                          instanceId="reasonGroup"
                          label="Grupo de natureza"
                          isMulti={true}
                          options={dispatchNatureGroups}
                          value={dispatchNatureGroups.filter(el => filters.natureGroup.includes(el))}
                          onChange={selected => handleInput('natureGroup', selected)}
                        />
                    </div>
                </form>
            </div>
        </>
    );
};

export default Filters;